type CourseType = {
	uuid: string;
	label: string;
	value: string;
};

export const courseTypes: CourseType[] = [
	{
		uuid: "9ed8e4f5-48e5-4f0c-85c8-5636522550ba",
		label: "Paid",
		value: "PAID",
	},
	{
		uuid: "9ed8e4f5-48f4-47d1-9838-9776f20061ae",
		label: "Free",
		value: "FREE",
	},
];
